<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('department.label')" :columns="6">
        <select v-model="filters.department" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="department in departments" :value="department.code" :key="department">{{ department.label }}</option>
        </select>
      </form-group>

      <form-group :label="$t('category.label')" :columns="6" v-if="categories.length">
        <select v-model="filters.category" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="category in categories" :value="category.code" :key="category">{{ category.label }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      departments: [],
      categories: [],
      filters: {
        brand: null,
        department: null,
        category: null
      },
      loading: false
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.getCategories('marketplace', 'cnova')
        .then(categories => { this.departments = categories })
        .catch(() => (this.departments = []))
    },
    watch: {
      'filters.department' (value) {
        this.loading = true

        if (value === null) {
          this.categories = []
          return false
        }

        api.getCategories('marketplace', 'cnova', this.filters.department)
          .then(categories => {
            this.categories = categories
            this.loading = false
          })
          .catch(() => (this.categories = []))
      }
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Cnova.vue?aea4f21c